export const getComplement = <T>(set1: Set<T>, set2: Set<T>) => {
  const ans = new Set<T>();
  for (const i of set1) {
    if (!set2.has(i)) {
      ans.add(i);
    }
  }
  return ans;
};

export const getIntersection = <T>(set1: Set<T>, set2: Set<T>) => {
  const ans = new Set<T>();
  for (const i of set2) {
    if (set1.has(i)) {
      ans.add(i);
    }
  }
  return ans;
};

export const getUnion = <T>(set1: Set<T>, set2: Set<T>) => {
  const ans = new Set<T>(set1);
  for (const i of set2) {
    ans.add(i);
  }
  return ans;
};
